import { useState } from "react";
import { faqs } from "@/mocks/discussion";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <p className="text-xs font-semibold uppercase tracking-wider text-primary-500">热议FAQ</p>
          <h2 className="section-title mt-2 text-2xl text-foreground-950 md:text-3xl">围观前，你可能想知道的</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm text-foreground-600 md:text-[15px]">
            关于参与讨论、热榜机制与投稿爆料，下面这些高频问题帮你快速上手爆料网。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((faq, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={
                  isOpen
                    ? "rounded-2xl border border-primary-200 bg-background-50 p-5"
                    : "rounded-2xl border border-background-200 bg-background-50 p-5"
                }
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full cursor-pointer items-center gap-3 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-100 font-bold text-primary-700">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="flex-1 text-[15px] font-bold text-foreground-950 md:text-base">{faq.q}</span>
                  <span
                    className={
                      isOpen
                        ? "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white transition-transform"
                        : "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-transform"
                    }
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true"></i>
                  </span>
                </button>

                {isOpen && (
                  <div className="anim-pop mt-3 border-t border-background-200 pl-11 pt-3">
                    <p className="text-sm leading-relaxed text-foreground-600 md:text-[15px]">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}